import { stateNameMap } from "../common/stateMappings"

export function processPerformanceDataProcessor(jobData) {
  const processMap = {}
  const allStatesSet = new Set()

  jobData.forEach(job => {
    const processName = job.releaseName
    processMap[processName] ??= { name: processName }

    const state = stateNameMap[job.state] || job.state
    allStatesSet.add(state)

    processMap[processName][state] = (processMap[processName][state] || 0) + 1
  })

  const data = Object.values(processMap)
  const categories = data.map(item => item.name)

  const series = Array.from(allStatesSet).map(state => ({
    name: state,
    data: data.map(item => item[state] || 0)
  }))

  return { series, categories }
}